var _circle, _g, _ellipse, _g2, _circle2, _path, _path2, _rect, _circle3, _g3, _circle4, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourtRecordAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 130,
    viewBox: "0 0 164 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.722,
    cy: 65.925,
    r: 63.37,
    transform: "rotate(90 63.722 65.925)",
    fill: "#E6F6FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1590_8384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.007,
    y: 9.25006,
    width: 102.659,
    height: 85.9212,
    rx: 1.85977,
    transform: "rotate(90 107.007 9.25006)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1590_8384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 127,
    height: 128
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.046,
    cy: 65.787,
    rx: 63.232,
    ry: 63.046,
    transform: "rotate(90 64.046 65.787)",
    fill: "#E6F6FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1590_8384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.006,
    y: 9.25018,
    width: 120.141,
    height: 85.9212,
    rx: 1.85977,
    transform: "rotate(90 107.006 9.25018)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 73.3525H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 28H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 78.9998H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 33.6474H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 73.3524H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 28H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 78.9998H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 33.6474H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 84.6472H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 39.2948H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 90.2946H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 44.9421H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 84.6472H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 39.2948H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 90.2946H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 44.9421H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 95.942H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 50.5895H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 101.589H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 56.2369H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 95.942H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 50.5895H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 101.589H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 56.2369H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 107.237H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 61.8843H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 107.237H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 61.8843H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 112.884H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9942 67.5317H51.7431",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 112.884H94.9052",
    stroke: "#00A6CA",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9871 67.5317H94.9052",
    stroke: "#005F8D",
    strokeWidth: 1.85977,
    strokeLinecap: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.978,
    cy: 67.9776,
    r: 27.1526,
    transform: "rotate(-45 102.978 67.9776)",
    fill: "white",
    stroke: "#005F8D",
    strokeWidth: 2.23172
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.021 51.934C121.128 54.0408 122.799 56.5421 123.94 59.2948C125.08 62.0476 125.667 64.998 125.667 67.9776C125.667 70.9572 125.08 73.9076 123.94 76.6604C122.799 79.4131 121.128 81.9144 119.021 84.0212",
    stroke: "#005F8D",
    strokeWidth: 1.48781,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.966 92.1746L127.175 87.9664L143.218 104.01C144.38 105.172 144.38 107.056 143.218 108.218C142.056 109.38 140.172 109.38 139.01 108.218L122.966 92.1746Z",
    fill: "#005F8D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.81,
    y: 89.0185,
    width: 5.95125,
    height: 3.34758,
    transform: "rotate(-45 119.81 89.0185)",
    fill: "#005F8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1590_8384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 41,
    width: 54,
    height: 54
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.983,
    cy: 67.9772,
    r: 26.0367,
    transform: "rotate(-45 102.983 67.9772)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1590_8384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.936 79.3292C109.758 79.3292 110.424 78.6631 110.424 77.8414C110.424 77.0197 109.758 76.3536 108.936 76.3536V79.3292ZM77.8783 79.3292H108.936V76.3536H77.8783V79.3292Z",
    fill: "#00A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.214 69.2864C114.035 69.2864 114.702 68.6203 114.702 67.7986C114.702 66.9769 114.035 66.3108 113.214 66.3108V69.2864ZM78.7771 69.2864C79.5988 69.2864 80.2649 68.6203 80.2649 67.7986C80.2649 66.9769 79.5988 66.3108 78.7771 66.3108V69.2864ZM85.0383 66.3108C84.2166 66.3108 83.5505 66.9769 83.5505 67.7986C83.5505 68.6203 84.2166 69.2864 85.0383 69.2864V66.3108ZM91.2995 69.2864C92.1212 69.2864 92.7873 68.6203 92.7873 67.7986C92.7873 66.9769 92.1212 66.3108 91.2995 66.3108V69.2864ZM97.5607 66.3108C96.739 66.3108 96.0729 66.9769 96.0729 67.7986C96.0729 68.6203 96.739 69.2864 97.5607 69.2864V66.3108ZM103.822 69.2864C104.644 69.2864 105.31 68.6203 105.31 67.7986C105.31 66.9769 104.644 66.3108 103.822 66.3108V69.2864ZM110.083 66.3108C109.261 66.3108 108.595 66.9769 108.595 67.7986C108.595 68.6203 109.261 69.2864 110.083 69.2864V66.3108ZM75.6465 69.2864H78.7771V66.3108H75.6465V69.2864ZM85.0383 69.2864H91.2995V66.3108H85.0383V69.2864ZM97.5607 69.2864H103.822V66.3108H97.5607V69.2864ZM110.083 69.2864H113.214V66.3108H110.083V69.2864Z",
    fill: "#FF7171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.936 59.6157C109.758 59.6157 110.424 58.9496 110.424 58.1279C110.424 57.3062 109.758 56.6401 108.936 56.6401V59.6157ZM77.8783 59.6157H108.936V56.6401H77.8783V59.6157Z",
    fill: "#00A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.098 49.573C112.919 49.573 113.586 48.9068 113.586 48.0851C113.586 47.2634 112.919 46.5973 112.098 46.5973V49.573ZM83.6433 49.573H112.098V46.5973H83.6433V49.573Z",
    fill: "#00A6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47 89.7439C113.292 89.7439 113.958 89.0777 113.958 88.256C113.958 87.4343 113.292 86.7682 112.47 86.7682V89.7439ZM84.2016 89.7439H112.47V86.7682H84.2016V89.7439Z",
    fill: "#00A6CA"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 16,
    fill: "#005F8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5454 20.5988H21.4529V19.6904H20.5454V20.5988ZM28.0215 8.88336C26.119 7.00526 23.6042 5.98094 20.9282 6.00027C18.2566 6.0196 15.7509 7.07802 13.8757 8.98227C10.0024 12.9135 10.0478 19.2652 13.9756 23.1419C15.6987 24.8427 17.9295 25.8397 20.3193 26V25.0894C18.1714 24.9336 16.1655 24.0264 14.6128 22.495C11.0417 18.9708 11.0008 13.1966 14.522 9.62232C16.228 7.89088 18.5042 6.92795 20.9338 6.9109C20.9554 6.9109 20.9781 6.9109 20.9997 6.9109C23.4043 6.9109 25.6692 7.83972 27.3832 9.53137C29.1131 11.2389 30.0751 13.5172 30.0922 15.949C30.1092 18.3807 29.179 20.6726 27.4741 22.4041C25.9145 23.9877 23.8768 24.9257 21.6812 25.0882V26C24.121 25.8363 26.3893 24.8006 28.1204 23.0419C29.9968 21.1376 31.019 18.6161 30.9997 15.941C30.9804 13.2671 29.9229 10.7603 28.0204 8.88222L28.0215 8.88336ZM21.4484 11.1866H20.5397V18.5217H21.4484V11.1866Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1590_8384",
    x: 17.3658,
    y: 4.78662,
    width: 93.3602,
    height: 110.098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.743906
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.85977
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1590_8384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1590_8384",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtRecordAlert);
export default __webpack_public_path__ + "static/media/court_record_alert.52006f48cc7c3f1063b14deb55a0d0cb.svg";
export { ForwardRef as ReactComponent };